import { render, staticRenderFns } from "./CEmailGroup.vue?vue&type=template&id=14b80a18&"
import script from "./CEmailGroup.vue?vue&type=script&lang=js&"
export * from "./CEmailGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports